/**
 * Adds a "neither" option to the smart meter questions
 * and controls it's clearing when ticking one of the other options
 * and the clearing of the other options when it's ticked
 * @module embed/smart_meter_options
 */

const SELECTOR = '.js-smart-meter-options';
const SELECTOR_TEMPLATE = '.js-smart-meter-options__template';
const SELECTOR_INPUT = '[type="checkbox"]';
const SELECTOR_NEITHER = `${SELECTOR_INPUT}[value=""]`;
const SELECTOR_OTHER = `${SELECTOR_INPUT}:not([value=""])`;

/**
 * @param {HTMLElement} el The element to which the option should get added
 */
function appendNeitherOption(el) {
  const neitherOption = el.querySelector(SELECTOR_TEMPLATE).cloneNode(true);
  // Update any reference to current value, which will update the IDs
  const templateValue = neitherOption
    .querySelector(SELECTOR_INPUT)
    .getAttribute('value');
  neitherOption.innerHTML = neitherOption.innerHTML.replace(
    new RegExp(templateValue, 'g'),
    'neither'
  );
  // Set the actual value and label
  neitherOption.querySelector(SELECTOR_INPUT).setAttribute('value', '');
  neitherOption.querySelector('label').textContent = 'Neither';
  el.appendChild(neitherOption);
}

function updateNeitherCheck(el) {
  if (el.querySelector(`${SELECTOR_OTHER}:checked`)) {
    el.querySelector(SELECTOR_NEITHER).checked = false;
  } else {
    el.querySelector(SELECTOR_NEITHER).checked = true;
  }
}

function uncheckNonNeitherOptions(el) {
  Array.from(el.querySelectorAll(`${SELECTOR_OTHER}`)).forEach(
    input => (input.checked = false)
  );
}

function setupSmartMeterOptionList(el) {
  appendNeitherOption(el);
  el.classList.add('bcs-radioCollection--thirds');

  el.addEventListener('change', ({ target }) => {
    if (!target.value) {
      uncheckNonNeitherOptions(el);
    }
    updateNeitherCheck(el);
  });
  updateNeitherCheck(el);
}

export default function setupSmartMeterOptions(el) {
  Array.from(el.querySelectorAll(SELECTOR)).forEach(optionList =>
    setupSmartMeterOptionList(optionList)
  );
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/smart_meter_options.js